/* eslint-disable max-len */
import React from 'react'

import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import AnimatedList from '../../../../../components/Animation/AnimatedList'
import moment from 'moment'
import { convertEpochToDateFormat } from '../../../../../CommonMethods/DateConversion'

const TableBody=({
    tableData,
    indexNum,
})=>{
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const fieldTOUpdate={
        'user_type':'User Type',
        'user_name':'Username',
        'user_id':'User ID',
        'main_number':'Main Number',
        'mobile_number':'Mobile Number',
        'email_address':'Email Address',
        'last_name':'Last Name',
        'first_name':'First Name',
        'Profile Page':'Profile Page',
        'address':'Address',
        'sub_divisions':'Sub Division ID',
        'organization_id':'Organization ID',
        
    }
    const actionToUpdate={
        'Added Sub Division':'Updated',
        'Added Organization':'Updated',
        'Deleted Organization':'Deleted',
        'Deleted Sub Division':'Deleted'
    }
    
    const date = convertEpochToDateFormat(tableData?.timestamp,dateformat)
    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {tableData?.user_name}
                        </td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {date}
                        </td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">{actionToUpdate[tableData?.action]?actionToUpdate[tableData?.action]:tableData?.action}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">{fieldTOUpdate[tableData?.field]?fieldTOUpdate[tableData?.field]:tableData?.field}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">{tableData?.old_value==='' ? '-' : tableData?.old_value}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624]">{tableData?.new_value==='' ?'-':tableData?.new_value==="corporate-user"?'Corporate User':tableData?.new_value==="admin-user"?'Admin User':tableData?.new_value}</td>
                        <td className="px-[18px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-sm rounded-bl-sm">{tableData?.comments===''?'-':tableData?.comments}</td>
                    </>
                    
                }/>
           
        </>
    )
}

export default TableBody